import HttpRequest from '../HttpRequest'

class WordpressProvider extends HttpRequest {
  fetchCategories (data = {}) {
    return this.fetch('/categories', data)
  }

  fetchPosts (data = {}) {
    return this.fetch('/posts', data)
  }

  fetchPost (id, data = {}) {
    return this.fetch(`/posts/${id}`, data)
  }
}

export default WordpressProvider
